import { useAuthStore } from "~/stores/auth";
import { useAppState } from "~/composables/useAppState";
import { computed } from "vue";

export function usePermission() {
    const authStore = useAuthStore();
    const appState = useAppState();

    /**
     * Check if the user has a specific permission in the CURRENT organization
     */
    const hasPermission = (permission: string): boolean => {
        const currentOrgId = appState.orgId.value;
        if (!currentOrgId) return false;
        
        return authStore.hasPermission(permission, currentOrgId);
    };

    return {
        hasPermission
    };
}
